<template>
  <div>
    <a-modal
      :visible="showModal"
      :footer="false"
      :width="550"
      class="modal-retur"
      @cancel="$emit('handleModal', false)"
    >
      <h4>
        {{ $t('inventory.goods_receipt.create_title') }}
      </h4>
      <hr />

      <div class="mt-4">
        {{ $t('inventory.goods_receipt.create_desc') }}
      </div>

      <div class="mt-3">
        <a-button class="inbound__button mx-2 ml-auto w-100" @click.prevent="createGr()">
          {{ $t('inventory.goods_receipt.without_ref') }}
        </a-button>
        <a-button class="w-100 mt-3" type="primary" :loading="loading" @click="handleShow">
          {{ $t('inventory.goods_receipt.use_po_ref') }}
        </a-button>
      </div>

      <!-- DATA --> <!-- LIST -->
      <div v-if="showTable">
        <a-divider />
        <div class="d-flex align-items-center mx-auto">
          <div class="search-bar">
            <a-input-search
              v-model="keyword"
              size="large"
              :placeholder="$t('inventory.goods_receipt.placeholder_po')"
              :loading="loading"
              :disabled="loading"
              allow-clear
              @search="handleSearch"
              @change="onChangeSearchBar"
            >
              <a-button slot="enterButton" :disabled="!keyword" type="danger" icon="search">
                {{ $t('utils.search') }}
              </a-button>
            </a-input-search>
          </div>
        </div>
        <div v-if="hasSearched" class="w-100 mt-2">
          <a-table
            size="small"
            class="table-list"
            :data-source="purchaseOrders"
            :row-key="record => record.id"
            :columns="columns"
            :loading="isLoading"
            :pagination="{
              pageSize: params.size,
              current: params.page,
              total: totalListPO,
              showTotal: (total, range) => $t('utils.pagination_show_total', { perpage: `${range[0]} - ${range[1]}`, total }),
              locale: { items_per_page: $t('utils.items_per_page') },
            }"
            :scroll="scroll"
            @change="onTableChange"
          >
            <template slot="supplierDO" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="PODate" slot-scope="text">
              {{ text ? $moment(text).format('DD MMM YYYY') : '-' }}
            </template>
            <template slot="requestDeliveryDate" slot-scope="text">
              {{ text ? $moment(text).format('DD MMM YYYY') : '-' }}
            </template>
            <template slot="status" slot-scope="text">
              <a-tag v-if="text" :color="stateColorTag[text]">
                {{ $t(`po.${text?.toLowerCase()}`) }}
              </a-tag>
              <span v-else> - </span>
            </template>
            <template slot="warehouseId" slot-scope="text">
              {{ findWarehouse(text, 'name') }}
            </template>
            <template slot="user_name" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="createdAt" slot-scope="text">
              {{ text ? $moment(text).format('DD MMM YYYY') : '-' }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-tooltip :title="isButtonDisabled(record) ? $t('inventory.goods_receipt.tooltip_disabled') : ''">
                <span>
                  <a-button :disabled="isButtonDisabled(record)" type="secondary" size="small" @click="createGr(record.id)">
                    {{ $t('inventory.goods_receipt.btn_create') }}
                  </a-button>
                </span>
              </a-tooltip>
            </template>
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getListPO } from '@/api/purchase-order'
import { columnsPurchaseOrder } from '@/data/columns'
export default {
  name: 'ModalRetur',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    pages: {
      type: String,
      default: '',
    },
    warehouse: {
      type: String,
      default: '',
    },
    // row: {
    //   type: Object,
    //   default: () => {},
    // },
    // params: {
    //   type: Object,
    //   default: () => {},
    // },
    // dataProductMaster: {
    //   type: Array,
    //   default: () => [],
    // },
    // sizeOption: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data: function() {
    return {
      showTable: false,
      keyword: '',
      dokumen: '',
      hasSearched: false,
      isLoading: false,
      purchaseOrders: [],
      warehouseList: [],
      stateColorTag: {
        CREATED: 'blue',
        PARTIAL_RECEIVED: 'orange',
        FULL_RECEIVED: 'green',
        CANCELED: 'red',
      },
      params: {
        query: '',
        sort: 'createdAt,desc',
        page: 1,
        size: 5,
      },
      totalListPO: 0,
    }
  },
  computed: {
    columns() {
      const titleMap = {
        number: 'po.columns.number',
        po_date: 'po.columns.po_date',
        supplier_do: 'po.columns.supplier_do',
        request_delivery_date: 'po.columns.delivery_date',
        supplier_code: 'po.columns.supplier',
        warehouse_id: 'po.columns.warehouse',
        user_name: 'po.columns.created_by',
        created_at: 'po.columns.created_at',
        status: 'po.columns.status',
      }
      return columnsPurchaseOrder.map(col => col.key === 'action'
        ? ({
          title: this.$t('utils.action') || '',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        })
        : {
          ...col,
          title: titleMap[col.key] ? this.$t(titleMap[col.key]) : col.title,
        },
      )
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    scroll() {
      const y = 360
      return { y, x: '1000px' }
    },
  },
  watch: {
    showModal: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (value === false) {
          this.visibleReject = value
          this.visibleUpdate = value
          this.isReason = ''
          // Reset all data when modal is closed
          this.showTable = false
          this.hasSearched = false
          this.keyword = ''
          this.purchaseOrders = []
          this.isLoading = false
          this.params = {
            query: '',
            sort: 'createdAt,desc',
            page: 1,
            size: 5,
          }
        }
      },
    },
  },
  methods: {
    isButtonDisabled(record) {
      const status = record && record.status ? String(record.status).toUpperCase() : ''
      return ['FULL_RECEIVED', 'CANCELED'].includes(status)
    },
    onTableChange(pagination) {
      const current = pagination?.current || 1
      const pageSize = pagination?.pageSize || this.params.size
      this.params.page = current
      this.params.size = pageSize
      if (this.hasSearched) {
        this.fetchListPO()
      }
    },
   handleShow() {
     this.showTable = !this.showTable
      if (!this.showTable) {
        this.hasSearched = false
        this.purchaseOrders = []
        this.keyword = ''
      }
      if (this.showTable) {
        this.fetchWarehouseList()
      }
    },
    createGr(poId) {
      this.$router.push({
        name: 'inventory.goods.receipt.create',
        query: {
          ...this.$route.query,
          warehouseId: this.warehouse,
          ...(poId ? { po_id: poId } : {}),
        },
      })
    },
    changePage(param) {
      this.$emit('onPageChangeMaster', param)
    },
    changeSize(current, size) {
      this.$emit('onShowSizeChangeMaster', size)
    },
    handleSearch() {
      if (!this.keyword) return
      this.hasSearched = true
      this.params.query = (this.keyword || '').trim()
      this.params.page = 1
      this.fetchListPO()
    },
    onChangeSearchBar(e) {
      const value = e?.target?.value || ''
      this.keyword = value
      if (!value) {
        this.hasSearched = false
        this.purchaseOrders = []
      }
    },
    fetchListPO() {
      this.isLoading = true
      const selectedBusinessId = this.$route.query.business_id || this.businessId
      getListPO({
        business_id: selectedBusinessId,
        params: {
          ...this.params,
          business_id: selectedBusinessId,
          warehouse_id: this.warehouse,
        },
      })
        .then(({ data }) => {
          this.purchaseOrders = data?.data || []
          this.totalListPO = data?.total_items || 0
        })
        .catch(() => {
          this.purchaseOrders = []
          this.totalListPO = 0
        })
        .finally(() => this.isLoading = false)
    },
    fetchWarehouseList() {
      const selectedBusinessId = this.$route.query.business_id || this.businessId
      this.$store.dispatch('warehouse/GETWAREHOUSELIST', {
        ...this.$route.query,
        business_id: selectedBusinessId,
        page: 1,
        size: 150,
      })
      .then(response => {
        this.warehouseList = response
      })
      .catch(err => {
        console.error(err)
        return err
      })
    },
    findWarehouse(id, field) {
      const warehouse = this.warehouseList.find((item) => item.id === id)
      return warehouse ? warehouse[field] : '-'
    },
  },
}
</script>

<style lang="scss">
.modal-retur {
  .list {
  border-radius: 5px;
  }
  .header-list {
    font-weight: 900;
    background: #E7ECEF;
    border-radius: 5px ;
    padding: 10px;
  }
  .data-list {
    padding: 5px 0;
    margin: 10px 0;
    background: #fff;
    border-radius: 5px ;
  }

  // ANT DESIGN
  // .ant-modal {
  //   width: 75% !important;
  // }
  .inbound__button {
    color: #ff0854 !important;
    background: #fff !important;
    border-color: #ff0854 !important;
  }
}
.inbound__button {
    color: #ff0854 !important;
    background: #fff !important;
    border-color: #ff0854 !important;
  }
.search-bar {
    position: relative;
    width: 534px;
    height: 44px;

    input[type='text'] {
      border: 1px solid #999;
      border-radius: 5px;
      width: 100%;
      outline: none;
      padding: 8px;
      box-sizing: border-box;
      transition: 0.3s;
    }

    input[type='text']:focus {
      border-color: rgb(5, 89, 203);
      box-shadow: 0 0 8px 0 rgb(5, 89, 203);
      color: #999;
    }

    input[type='text'] {
      padding-left: 10px;
    }

    input::placeholder {
      color: #999 !important;
      font-family: 'Poppins', sans-serif !important;
      font-style: normal !important;
      font-weight: 500 !important;
      font-size: 14px !important;
      line-height: 21px !important;
    }
    .icon-form {
      position: absolute;
      left: 7px;
      top: 10px;
      color: #999;
      transition: 0.3s;
    }
  }
</style>